import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes", isCompression: false });
export default ls;
